export function normalizeCustomerSearch(value) {
  if (!value) return "";
  return String(value)
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim();
}

export function matchesCustomerSearch(customer, query) {
  const q = normalizeCustomerSearch(query);
  if (!q) return false;
  const name = normalizeCustomerSearch(customer.name || "");
  const phoneDigits = (customer.phone || "").replace(/\D/g, "");
  const qDigits = q.replace(/\D/g, "");
  if (name === q || name.startsWith(q)) return true;
  if (qDigits) {
    return phoneDigits === qDigits || phoneDigits.startsWith(qDigits);
  }
  return false;
}

export function filterCustomers(customers, query, limit = 50) {
  const q = normalizeCustomerSearch(query);
  if (!q) return customers.slice(0, limit);
  return customers.filter((c) => matchesCustomerSearch(c, q)).slice(0, limit);
}
